import { quSave } from '@/service/question'
import util from '@/tools/commonUtil'
import iconSrc from '@/assets/images/edit/config/m-rig-checkbox@2x.png'
export default {
  id: '',
  groupId: '',
  belongId: '',
  orderById: 50,
  elementType: 'CheckBox',
  elementDesc: '多选题',
  type: 'checkbox',
  config: true,
  title: '多选题',
  placeholder: '多选题',
  isRequired: '1',
  maxLength: 20,
  itemName: 'optionList',
  optionList: [{
    orderById: '1',
    optionName: '',
    type: 'normal',
    imgUrl: '',
    imgName: ''
  }, {
    orderById: '2',
    optionName: '',
    type: 'normal',
    imgUrl: '',
    imgName: ''
  }],
  value: [],
  vertical: true,
  ruleError: '该字段不能为空',
  // 选项随机排列   0顺序排列1随机排列2循环显示
  randOrder: '0',
  saveUrl: '/design/qu-checkbox/ajaxSave.do',
  iconStyle: {
    width: '11px',
    height: '11px',
    background: 'url(' + iconSrc + ')'
  },
  ifOpenGroup: false, // 是否开启分组
  optionGroupList: [],
  saveFn () {
    return quSave({
      optionList: util.genList(this.optionList)
    }, this)
  },
  saveCb (data) {
    this.optionList = util.genRetList.call(this, data.optionList, 'option', {
      otherValue: ''
    })
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      quItemId: this.value.join(',')
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/CheckBox/config.js